const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { plansName, sideImage } = attributes;

  return (
    <section className={`PlansDetailsGridPlans Container`}>
      <div className={`plansContainer ${plansName}`} style='display: none;'>
        <div className="contentContainer">
          <InnerBlocks.Content />
        </div>
        <div className="imageContainer">
          {sideImage.src && (
            <figure>
              <img
                src={sideImage.src}
                alt={sideImage.alt}
                height={sideImage.height}
              />

              {/* {withFigcaption && (
                  <RichText.Content
                    tagName="figcaption"
                    className={`Typography text left color-black margin-none`}
                    value={figcaption}
                  />
                )} */}
            </figure>
          )}
        </div>
      </div>
    </section>
  );
};

export default Save;
